export default __webpack_public_path__ + "static/HHT-Budgetmeldung_1_1_de-8dc3ab3d8f4d325a056a96a02cd45e14.jpg";